import Banner from '@sats-group/ui-lib/react/banner';
import ProgressBar from '@sats-group/ui-lib/react/progress-bar';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import Logo from '../logo/logo';
import Prompt from '../prompt/prompt';
import type { ShopLayout as Props } from './shop-layout.types';

/** https://www.figma.com/design/VYtHMl4Z4ubu1fuhQeDZEG/Framework?node-id=5352-29931 */
const ShopLayout = <Primary, Secondary, Tertiary>({
  flipped,
  header,
  messages,
  primary,
  primaryRenderer,
  prompt,
  secondary,
  secondaryRenderer,
  tertiary,
  tertiaryRenderer,
  title,
}: Props<Primary, Secondary, Tertiary> & {
  primaryRenderer: (props: Primary) => React.ReactNode;
  secondaryRenderer: (props: Secondary) => React.ReactNode;
  tertiaryRenderer: (props: Tertiary) => React.ReactNode;
}) => (
  <div className="shop-layout">
    <header className="shop-layout__header">
      <Logo {...header.logo} />
      {header.progress ? (
        <div className="shop-layout__header-progress">
          <ProgressBar
            {...header.progress}
            variant={ProgressBar.variants.cta}
            theme={ProgressBar.themes.dark}
            labelAlignment={ProgressBar.labelAlignments.left}
            labelPosition={ProgressBar.labelPositions.topLeft}
          />
        </div>
      ) : null}
    </header>
    <main
      className={cn('shop-layout__content', {
        'shop-layout__content--flipped': flipped,
      })}
    >
      <section className="shop-layout__primary">
        <div className="shop-layout__title">
          <Text
            elementName="h1"
            size={Text.sizes.headline1}
            theme={Text.themes.emphasis}
          >
            {title}
          </Text>
        </div>
        <div className="shop-layout__messages">
          {prompt ? <Prompt {...prompt} /> : null}
          {messages.map(entry => (
            <div key={entry.text}>
              <Banner {...entry} />
            </div>
          ))}
        </div>
        <div className="shop-layout__primary-content">
          {primaryRenderer(primary)}
        </div>
      </section>
      <section className="shop-layout__secondary">
        {secondaryRenderer(secondary)}
      </section>
      <section className="shop-layout__tertiary">
        {tertiary ? tertiaryRenderer(tertiary) : null}
      </section>
    </main>
  </div>
);

export default ShopLayout;
